import maEventbus from '@/components/eventbus'
import maModal from '@/components/modal'
import maPoligons from '@/components/poligons'
import maInput from '@/components/input'
import { numericInputValidation } from '@/mixins/numericInputValidation'

export default {
  name: 'InputTextMap',
  extends: maInput,
  mixins: [numericInputValidation],

  components: {
    maModal,
    maPoligons
  },

  data() {
    return {
      mapValue: this.value || ''
    }
  },

  props: {
    coordinates: {
      type: Object
    }
  },

  computed: {
    lat() {
      return this.coordinates ? this.coordinates.lat : null
    },
    lng() {
      return this.coordinates ? this.coordinates.lng : null
    }
  },

  methods: {
    handleShowModal() {
      this.$refs[`input${this.type}${this.name}`].showModal = true
    },

    handlePolygonChange(v) {
      let sanitized = String(v)
      
      if (this.shouldValidateNumericField(this.name)) {
        sanitized = this.sanitizeNumericValue(sanitized)
      }
      
      this.mapValue = sanitized
      this.$refs[`input${this.type}${this.name}`].showModal = false
    },

    handleInput(value) {
      let sanitized = value
      
      if (this.shouldValidateNumericField(this.name)) {
        sanitized = this.sanitizeNumericValue(value)
      }
      
      this.mapValue = sanitized
    },

    handleKeydown(event) {
      if (this.shouldValidateNumericField(this.name)) {
        this.preventInvalidNumericKeys(event)
      }
    },

    cleanInitialValue() {
      if (this.shouldValidateNumericField(this.name)) {
        if (this.value === 0 || this.value === '0') {
          this.mapValue = ''
          this.$nextTick(() => {
            this.$emit('change', '')
          })
        }
      }
    }
  },

  mounted() {
    this.cleanInitialValue()
    
    maEventbus.$on('map:update',
      coordinates => {
        this.lat = coordinates.lat
        this.lng = coordinates.lng
      }
    )
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.shouldValidateNumericField(this.name) && (newVal === 0 || newVal === '0')) {
          this.mapValue = ''
        } else {
          this.mapValue = newVal || ''
        }
      }
    },
    
    mapValue(newV) {
      this.$emit('change', newV)
    }
  }
}